// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3307":"b1d1a335","4964":"b1d1a335","5400":"b1d1a335","6773":"b1d1a335","7934":"b1d1a335"}[chunkId] + ".chunk.css";
};